export const atcTipusReducer = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_ATC_TIPUS':
      return action.payload;
    default:
      return state;
  }
};

export const atcSubtipusReducer = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_ATC_SUBTIPUS':
      return action.payload;
    default:
      return state;
  }
};
